import { fetchAPI } from '@/shared/lib/api/client';

import type { WithdrawalRequest } from '../model/types';

export interface WithdrawResponse {
  id: string;
  amount: number;
  wallet_address: string;
  status: string;
  created_at: string;
}

export const withdrawApi = {
  async postWithdraw(amount: number, wallet: string): Promise<WithdrawResponse> {
    const { data } = await fetchAPI.post<WithdrawResponse>('/withdraw', {
      amount,
      wallet_address: wallet,
    });
    return data;
  },

  async getWithdrawalHistory(): Promise<WithdrawalRequest[]> {
    const { data } = await fetchAPI.get<WithdrawalRequest[]>('/withdraw/history');
    return data;
  },
};
